import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import './map-vehicle-icon.less';
import _ from 'lodash';

@propTypes({
    device: PropTypes.object.isRequired,
    direction: PropTypes.number,
})

@defaultProps({})

export default class MapVehicleIcon extends Component {

    render() {
        const className = classNames('marker__icon', `icon-${this.props.device.type}`);

        return (
            <div>
                <span className={className}/>
                <div className="marker__center">
                    {!_.isUndefined(this.props.direction) ? (
                        <span className="marker__direction" style={{transform: `rotate(${this.props.direction}deg)`}}/>
                    ) : null}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/map-vehicle-icon.js